import React from "react"
import PropTypes from "prop-types"

import Search from "../../../gd-components/popover-menu/search/search"

export default class SelectGenericPopoverSearch extends React.PureComponent {
    static propTypes = {
        searchString    : PropTypes.string,

        searchable      : PropTypes.bool,

        onSearchChange  : PropTypes.func,
        onHidePopover   : PropTypes.func,
    }

    render() {
        if (this.props.searchable) {
            return <Search searchString={this.props.searchString} onSearch={this.props.onSearchChange} onEscapePressed={this.props.onHidePopover}/>;
        } else {
            // still need to autofocus so keyboard work
            return <span className="hidden-search-input" tabIndex="0" />
        }
    }
}